document.addEventListener('DOMContentLoaded', function() {
  // Product thumbnail switching
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.getElementById('mainProductImage');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
      }
    });
  });

  // Quantity controls
  var qtyInput = document.querySelector('.qty-input');
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus = document.querySelector('.qty-plus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Variant selection
  var variants = document.querySelectorAll('.product-variant');
  variants.forEach(function(v) {
    v.addEventListener('click', function() {
      variants.forEach(function(x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Hero carousel
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  var currentSlide = 0;
  var slideTimer;

  function goToSlide(index) {
    slides.forEach(function(s) { s.classList.remove('active'); });
    dots.forEach(function(d) { d.classList.remove('active'); });
    slides[index].classList.add('active');
    dots[index].classList.add('active');
    currentSlide = index;
  }

  function nextSlide() {
    var next = (currentSlide + 1) % slides.length;
    goToSlide(next);
  }

  function startAutoPlay() {
    slideTimer = setInterval(nextSlide, 5000);
  }

  function stopAutoPlay() {
    clearInterval(slideTimer);
  }

  if (slides.length > 1) {
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAutoPlay();
        goToSlide(parseInt(this.dataset.slide));
        startAutoPlay();
      });
    });
    startAutoPlay();
  }
});
